import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable no-console */
import { noop } from '@beef/utils';
var createLog = function createLog(prefix, color) {
  return function (message) {
    console.groupCollapsed("[".concat(prefix, "] %c").concat(message), "color:".concat(color, ";font-weight:bold;"));
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    args.forEach(function (arg) {
      if (Array.isArray(arg)) {
        var _console;
        (_console = console).debug.apply(_console, _toConsumableArray(arg));
      } else {
        console.debug(arg);
      }
    });
    console.debug('%cDocumentation: %clink to documentation', 'font-weight:bold', 'font-weight:normal');
    console.groupEnd();
  };
};
var levels = ['debug', 'info', 'warn', 'error', 'silent'];
export var createLogger = function createLogger(prefix) {
  var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'silent';
  var methods = {
    debug: createLog(prefix, 'green'),
    error: createLog(prefix, 'red'),
    warn: createLog(prefix, 'yellow'),
    info: createLog(prefix, 'green'),
    silent: noop
  };
  var methodFactory = function methodFactory(availableLevels) {
    return levels.reduce(function (result, methodName) {
      return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, methodName, availableLevels.includes(methodName) ? methods[methodName] : noop));
    }, methods);
  };
  return _objectSpread(_objectSpread({}, methodFactory(levels.slice(levels.indexOf(level)))), {}, {
    setLevel: function setLevel(newLevel) {
      var _this = this;
      var availableMethods = methodFactory(levels.slice(levels.indexOf(newLevel)));
      Object.keys(availableMethods).forEach(function (methodName) {
        _this[methodName] = availableMethods[methodName];
      });
    }
  });
};
export var logger = createLogger('Metric');